import { useState } from 'react';
import { api, ApiFoutException } from '../api/client';

export function Inlogscherm({ onIngelogd }: { onIngelogd: () => void }) {
  const [gebruikersnaam, setGebruikersnaam] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [fout, setFout] = useState<string | null>(null);
  const [bezig, setBezig] = useState(false);

  const verzend = async () => {
    setBezig(true);
    setFout(null);
    try {
      await api.login(gebruikersnaam.trim(), wachtwoord);
      onIngelogd();
    } catch (f) {
      setFout(f instanceof ApiFoutException ? f.message : 'Inloggen mislukt.');
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="startscherm">
      <form
        className="inlog"
        onSubmit={(e) => {
          e.preventDefault();
          void verzend();
        }}
      >
        <h1>Video Studio</h1>
        <p className="startscherm__onder">Log in om projecten, media en generaties te openen.</p>
        {fout && (
          <div className="melding melding--fout" role="alert">
            {fout}
          </div>
        )}
        <label className="veld">
          <span>Gebruikersnaam</span>
          <input
            type="text"
            autoComplete="username"
            value={gebruikersnaam}
            onChange={(e) => setGebruikersnaam(e.target.value)}
            required
          />
        </label>
        <label className="veld">
          <span>Wachtwoord</span>
          <input
            type="password"
            autoComplete="current-password"
            value={wachtwoord}
            onChange={(e) => setWachtwoord(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="knop knop--primair knop--breed" disabled={bezig}>
          {bezig ? 'Bezig…' : 'Inloggen'}
        </button>
      </form>
    </div>
  );
}
